import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { CopyService } from '../../services/copy.service';
import { RegistrationService } from '../../services/registration.service';
import moment from 'moment-timezone';
import _ from 'lodash';
import * as _moment from 'moment';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ConstantsService } from '../../services/constants.service';
import { ListManagerService } from 'src/app/services/list-manager.service';
import { GuestService } from 'src/app/services/guest.service';
import { ModalService } from '../../services/modal.service';
import { AirportService } from '../../services/airport.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { NgbDateStruct, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { VariablesService } from 'src/app/services/variables.service';

@Component({
    selector: 'app-travel',
    templateUrl: './travel.component.html',
    styleUrls: ['./travel.component.scss'],
    standalone: false
})
export class TravelComponent implements OnInit {
  isSubmitting;
  travelTypes;
  programInfo: any;
  attendee: any;
  enrollment: any;
  guests: any;
  passport: any;
  ownAir: any;
  isRegComplete: any;
  countryList: any;
  isError: any;
  prefixList: any;
  suffixList: any;
  genderRadios: any;
  eventDates: any;

  //For flight preference
  travelTimes: any;
  timesRadios: any;
  groupArrivalDate: any;
  groupDepartureDate: any;
  calendarready: any;
  options: any;
  airlineList: any;
  frequentFlyer = [];
  flightPrefRadios;
  participant;
  locations;
  startDateOutbound;
  endDateOutbound;
  startDateReturn;
  endDateReturn;
  search;
  startDateOutboundYear: number;
  startDateOutboundMonth: number;
  startDateOutboundDay: number;
  formatter = (result: string) => result.toUpperCase();
  startDate;
  startDateRet;
  endDate;
  endDateRet;
  outboundDateTime;
  returnDateTime;
  isFormCompleted=false;
  otherNumber:any;
  otherNumberBox=false;
  airR;
  accepAir;
  respAir;
  showAirQuestForthisPAX=undefined;

 /*  airportLocationsList=[
    {
      "locationCode": 18964,
      "airport": "John Wayne International Airport",
      "city": "Santa Ana",
      "state": "California",
      "country": "USA",
      "formattedAirport": "John Wayne International Airport - SNA - Santa Ana, Californ",
      "crscode": "SNA"
    },
    {
      "locationCode": 18398,
      "airport": "Los Angeles International Airport",
      "city": "Los Angeles",
      "state": "California",
      "country": "USA",
      "formattedAirport": "Los Angeles International Airport - LAX - Los Angeles, Calif",
      "crscode": "LAX"
  }
  ]; */


  constructor(private navigationService: NavigationService,
    private copyService: CopyService,
    private registrationService: RegistrationService,
    public Constants: ConstantsService,
    private configurationService: ConfigurationService,
    private listService: ListManagerService,
    private guestService: GuestService,
    public modalService: ModalService,
    private matDialog: MatDialog,
    private airportService: AirportService,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private dateAdapter: NgbDateAdapter<string>,
    private variables: VariablesService) {

    this.attendee = this.registrationService.getAttendee({});
    this.otherNumber = this.registrationService.getVariable(this.attendee,variables.VARIABLE.redressCheck.ID,{});
    if(this.otherNumber.Value==="Yes"){
      this.otherNumberBox = true;
    }

    this.enrollment = this.registrationService.getEnrollment({});
    this.guests = this.registrationService.getGuests({});
    this.passport = this.registrationService.getTravelDocument(this.attendee, Constants.DOCUMENT_TYPES.PASSPORT, {});
    this.attendee.$mtcOutbound = this.registrationService.getPAXAirPreference(this.attendee, Constants.AIRPREF_DIRECTIONS.OUTBOUND, {});
    this.attendee.$mtcReturn = this.registrationService.getPAXAirPreference(this.attendee, Constants.AIRPREF_DIRECTIONS.RETURN, {});
    this.ownAir = this.registrationService.getOwnAir(this.attendee);
    this.accepAir = registrationService.getVariable(this.attendee, variables.VARIABLE.accepAir.ID, {});
    this.respAir = registrationService.getVariable(this.attendee, variables.VARIABLE.respAir.ID, {});
    //this.airR = registrationService.getVariable(this.attendee, variables.VARIABLE.airReimbursment.ID, {});
    if (this.attendee.FrequentFlyer === undefined) {
      this.attendee.FrequentFlyer = [];
    }

    this.listService.getCountryList().then(data => {
      this.countryList = data;
    });

    this.listService.getCommonPrefixList().then(list => {
      this.prefixList = list;
    });

    this.listService.getSuffixList().then(list => {
      this.suffixList = list;
    });

    this.listService.getFrequentFlyerList().then(data => {
      this.airlineList = data;
    });

    this.listService.getTravelTimeList().then(data => {
      this.travelTimes = data;
    });

    this.search = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => term === '' ? []
          : this.airportService.getAirportLocations(term).then(data => {
            this.locations = data;
            this.locations.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
          })
        ))

    copyService.getCopyByKey('arrivalDate').then((data) => {
      if (!this.attendee.$mtcOutbound.DepartureDateTime) {
        this.attendee.$mtcOutbound.DepartureDateTime = data;
      }
      this.outboundDateTime = this.convertToDatePicker(this.attendee.$mtcOutbound.DepartureDateTime);
    });
    copyService.getCopyByKey('departureDate').then((data) => {
      if (!this.attendee.$mtcReturn.DepartureDateTime) {
        this.attendee.$mtcReturn.DepartureDateTime = data;
      }
      this.returnDateTime = this.convertToDatePicker(this.attendee.$mtcReturn.DepartureDateTime);
    });
  }

  otherNumChange(){
    console.log(this.otherNumberBox);
    if(this.otherNumberBox){
      this.otherNumber.Value = "Yes";
    }else{
      this.otherNumber.Value = "";
    }
  }

  convertToDatePicker(datestring) {
    let dateobj = moment.utc(datestring, 'YYYY-MM-DD HH:mm:ss+Z').toDate();
    return {
      year: dateobj.getFullYear(),
      month: dateobj.getMonth() + 1,
      day: dateobj.getDate(),
    };

    // return this.ngbDateParserFormatter.parse(datestring);
  }

  showAirQuest(){
    //console.log(this.enrollment);
    this.showAirQuestForthisPAX=true;

    /*if(this.accepAir.Value=="No"){
      this.showAirQuestForthisPAX=false;
      this.attendee.TravelType=undefined;
      this.cleanAirTravelInfo();
    }*/
  }

  ngOnInit(): void {
    this.calendarready = false;
    this.options = {
      showWeeks: false,
      startingDay: "0"
    };
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;

      this.startDateOutbound = moment.utc(this.programInfo.airOutboundDateBegin, "YYYY-MM-DD HH:mm:ss+Z").toDate();
      this.startDate = { year: this.startDateOutbound.getFullYear(), month: (this.startDateOutbound.getMonth()) + 1, day: this.startDateOutbound.getDate() };
      this.endDateOutbound = moment.utc(this.programInfo.airOutboundDateEnd, "YYYY-MM-DD HH:mm:ss+Z").toDate();
      this.endDate = { year: this.endDateOutbound.getFullYear(), month: (this.endDateOutbound.getMonth()) + 1, day: this.endDateOutbound.getDate() };

      //this.startDateReturn = moment.utc(this.getMinimumDepartureDate(), "YYYY-MM-DD HH:mm:ss+Z").toDate();
      this.startDateReturn = moment.utc(this.programInfo.airReturnDateBegin, "YYYY-MM-DD HH:mm:ss+Z").toDate();
      this.startDateRet = { year: this.startDateReturn.getFullYear(), month: (this.startDateReturn.getMonth()) + 1, day: this.startDateReturn .getDate() };
      this.endDateReturn = moment.utc(this.programInfo.airReturnDateEnd, "YYYY-MM-DD HH:mm:ss+Z").toDate();

      this.endDateRet = { year: this.endDateReturn.getFullYear(), month: (this.endDateReturn.getMonth()) + 1, day: this.endDateReturn.getDate() };

      this.travelTypes = [
        {
          display: this.copyService.getCopyByKey(
            'copy.label.TRAVEL.fly'
          ),
          value: this.Constants.TRAVEL_TYPES.FLY
        },
        {
          display: this.copyService.getCopyByKey(
            'copy.label.TRAVEL.ownair'
          ),
          value: this.Constants.TRAVEL_TYPES.OWN_AIR
        },
        {
          display: this.copyService.getCopyByKey(
            'copy.label.TRAVEL.drive'
          ),
          value: this.Constants.TRAVEL_TYPES.DRIVE
        }
      ];

     /*  if(this.attendee.PAXTypeNo===1){
        _.remove(this.travelTypes,{value: 'OWNAIR'});
      } 
      if(this.attendee.PAXTypeNo===2 || this.attendee.PAXTypeNo===6){
        _.remove(this.travelTypes,{value: 'FLY'});
      }*/


      this.genderRadios = [
        {
          display: this.copyService.getCopyByKey(
            'copy.label.FEATURES.GENDER.male'
          ),
          value: "MALE"
        },
        {
          display: this.copyService.getCopyByKey(
            'copy.label.FEATURES.GENDER.female'
          ),
          value: "FEMALE"
        }
      ];

      this.flightPrefRadios = [
        {
          display: this.copyService.getCopyByKey(
            'copy.label.FEATURES.SEATPREF.window'
          ),
          value: this.Constants.REQUESTED_SEAT_TYPES.WINDOW
        },
        {
          display: this.copyService.getCopyByKey(
            'copy.label.FEATURES.SEATPREF.aisle'
          ),
          value: this.Constants.REQUESTED_SEAT_TYPES.AISLE
        },
        {
          display: this.copyService.getCopyByKey(
            'copy.label.FEATURES.SEATPREF.nopref'
          ),
          value: this.Constants.REQUESTED_SEAT_TYPES.NOPREF
        }
      ];

      // For flight preference
      this.groupArrivalDate = moment.utc(this.programInfo.arrivalDate, "YYYY-MM-DD HH:mm:ss+Z").toDate();
      this.groupDepartureDate = moment.utc(this.programInfo.departureDate, "YYYY-MM-DD HH:mm:ss+Z").toDate();
      this.calendarready = true;

      if (!this.attendee.$mtcReturn.DepartureCityLocation && this.programInfo.programDepartureCityAirport) {
        this.attendee.$mtcReturn.DepartureCityLocation = this.programInfo.programDepartureCityAirport;
      }

      if (!this.attendee.$mtcReturn.DepartureAirportCode && this.programInfo.programDepartureCityAirportCode) {
        this.attendee.$mtcReturn.DepartureAirportCode = this.programInfo.programDepartureCityAirportCode;
      }

      if(this.accepAir.Value) this.showAirQuestForthisPAX=true;

      if(this.attendee.PAXTypeNo!==4 || this.showAirQuestForthisPAX!=undefined ){
        this.showAirQuestForthisPAX=true;
      }

    });


  }

  /**
    * @function back
    * @description Uses [navigation.service.back()] to go back to previous page.
    */
  back() {
    this.cleanAirTravelInfo();
    this.navigationService.back();
  }

  /**
     * @function forward
     * @description Checks if form is valid then uses [NavigationService.forward()](./app.NavigationService.html) to go forward to next page.
     */
  forward(form) {
    this.isFormCompleted = true;
    if (this.attendee.TravelType !== undefined && form.valid) {
       if (this.attendee.NoMiddleNameFlag) {
        this.attendee.MiddleName = "";
       }
      this.respAir.Value= this.enrollment.$mtcRespAir?"Yes":"";
      this.isSubmitting = true;
      this.cleanAirTravelInfo();
      this.navigationService.forward();
     }
  }

  convertToRealDate(d) {
    return this.ngbDateParserFormatter.format(d) + 'T12:00:00-0500';;
  }

  updateModel(){
    this.attendee.$mtcOutbound.DepartureDateTime = this.convertToRealDate(this.outboundDateTime);
    this.attendee.$mtcReturn.DepartureDateTime = this.convertToRealDate(this.returnDateTime);

    let departdate = moment.utc(this.attendee.$mtcOutbound.DepartureDateTime, "YYYY-MM-DD HH:mm:ss+Z").toDate();
    let retdate = moment.utc(this.attendee.$mtcReturn.DepartureDateTime, "YYYY-MM-DD HH:mm:ss+Z").toDate();

    if(departdate < this.groupArrivalDate){
      this.attendee.TravelPlan = 'EXT';
    }else if(this.groupDepartureDate < retdate){
      this.attendee.TravelPlan = 'EXT';
    }else{
      this.attendee.TravelPlan = 'PGMDATE';
    }

  }

  format(date){
    return this.convertToRealDate(date);
  }

  /**
     * @function TravelController.getMinimumDepartureDate
     * @returns {Window.programInfo.airReturnDateBegin|this.programInfo.airReturnDateBegin|Window.attendee.$mtcOutbound.DepartureDateTime|this.attendee.$mtcOutbound.DepartureDateTime}
     */
  getMinimumDepartureDate() {
    if (this.programInfo && this.programInfo.airReturnDateBegin) {
      if (this.attendee.$mtcOutbound.DepartureDateTime > this.programInfo.airReturnDateBegin) {
        return this.attendee.$mtcOutbound.DepartureDateTime;
      } else {
        return this.programInfo.airReturnDateBegin;
      }
    } else {
      return undefined;
    }
  }

  cleanProcess(){
    this.enrollment.AirSpecialRequests = undefined;
    this.attendee.MiddleName = undefined;
    this.attendee.Gender = undefined;
    //this.attendee.BirthDate = undefined;
    this.attendee.RedressNumber = undefined;
    this.attendee.KnownTravelerNumber = undefined;
    this.attendee.InterRowPosition = undefined;
    this.attendee.IssuingCountryISOCode = undefined;
    this.attendee.$mtcProvidePassport = undefined;
    this.attendee.FrequentFlyer = [];
    this.attendee.TravelDocument = [];
    this.attendee.PAXAirPreference = [];
    this.attendee.$mtcOutbound = {};
    this.attendee.$mtcReturn = {};
    if (this.guests.length > 0) {
      _.each(this.guests, (guest) => {
        guest.TravelType = this.attendee.TravelType;
        guest.MiddleName = undefined;
        guest.Gender = undefined;
        if (!this.guestService.isChild(guest)) {
          guest.BirthDate = undefined;
        }
        guest.RedressNumber = undefined;
        guest.KnownTravelerNumber = undefined;
        guest.InterRowPosition = undefined;
        guest.IssuingCountryISOCode = undefined;
        guest.FrequentFlyer = [];
        guest.PAXAirPreference = [];
        guest.$mtcSameItinerary = undefined;
        guest.$mtcOutbound = {};
        guest.$mtcReturn = {};
      });
    }
  }

  /**
    * @function cleanAirTravelInfo
    */
  cleanAirTravelInfo() {
    if (this.attendee.TravelType === this.Constants.TRAVEL_TYPES.RAIL) {
      this.attendee.PAXAirPreference.forEach( (airpref) => {
        airpref.DepartureAirportCode = undefined;
      });
    }
    if (this.attendee.TravelType && this.attendee.TravelType !== this.Constants.TRAVEL_TYPES.FLY && this.attendee.TravelType !== this.Constants.TRAVEL_TYPES.RAIL) {
      this.cleanProcess();
    }
    if (!this.showAirQuestForthisPAX && this.attendee.TravelType !== this.Constants.TRAVEL_TYPES.FLY && this.attendee.TravelType !== this.Constants.TRAVEL_TYPES.RAIL) {
      this.cleanProcess();
    }
  }

  /**
    * @function FrequentFlyerDirective.addFrequentFlyer
    * @description Adds frequent flyer information.
    */
  addFrequentFlyer() {
    this.attendee.FrequentFlyer.push({});
  }

  /**
  * @function FrequentFlyerDirective.removeFrequentFlyer
  * @description Removes frequent flyer information.
  */
  removeFrequentFlyer(index) {
    this.attendee.FrequentFlyer.splice(index, 1);
  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component-terms";
  }

  filterAirlines(airlinelist, code) {
    let selected = [];
    if(this.attendee.FrequentFlyer) {
      this.attendee.FrequentFlyer.forEach(flier => {
        if(flier.AirlineCode && flier.AirlineCode !== code) {
          selected.push(flier.AirlineCode);
        }
      });
    }
    const filteredlist = _.filter(airlinelist, o => {
      if(selected.indexOf(o.code) >= 0) {
        return false;
      } else {
        return true;
      }
    });
    return filteredlist;
  }

 /*  selectDCL(location){
    //console.log(location);
    let returnLoc=_.filter(this.airportLocationsList, {crscode: location});
    this.attendee.$mtcReturn.DepartureCityLocation = returnLoc[0].formattedAirport;

  } */

}
